import React from 'react';
import SurveyHeader from '../components/SurveyHeader';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import { Typography } from '@mui/material';
import { useAppSelector } from '../redux/ReduxProvider';

const useStyles = makeStyles((theme) => ({
  root: theme.defaultLayout.root,
  title: theme.defaultLayout.title,
  container: theme.defaultLayout.container,
  content: theme.defaultLayout.content,
}));

const NoMatchPage = () => {
  const styles = useStyles();
  const { t } = useTranslation();

  const { logoUrl: companyLogoUrl, brandColor: companyBackgroundColor } = useAppSelector((state) => state.company);

  return (
    <div className={styles.root}>
      <SurveyHeader backgroundColor={companyBackgroundColor} logoUrl={companyLogoUrl} />

      <article className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>{t('survey.not-found.title')}</h1>
          <Typography>{t('survey.not-found.message')}</Typography>
        </div>
      </article>
    </div>
  );
};

export default NoMatchPage;
